export const multiSiteLeadMap = {
    'UWA6': 'Nielson',
    'MAM7': 'Meyali Staup',
    'MAJ2': 'Martha Marinelli',
    'UNJ2': 'Gogliormella',
    'USV1': 'Beatriz Cortes Marin',
    'ULO1': 'Jordan Elloway',
    'USF1': 'Coleman',
    'USF2': 'Coleman',
    'MAF7': 'Lionel Triplett',
    'UOH4': 'Salehin',
    'UTX3': 'Salehin',
    'UNY5': 'Oppedisano',
    'MAB2': 'Stockton Young',
    'UIL2': 'Salehin',
    'UFL6': 'Persaud',
    'UBA1': "Pietro D'Agostini",
    'MAC0': 'Deron Thompson',
    'UCA6': 'Khalaf',
    'MAI8': 'Deron Thompson',
    'MAB6': 'Stockton Young',
    'MAJ5': 'Martha Marinelli',
    'ULI2': 'Paul Tinsley',
    'MAB1': 'Meyali Staup',
    'MAC3': 'Kevin Johnson',
    'UWI2': 'Salehin',
    'MAC7': 'Martha Marinelli',
    'MAB9': 'Deron Thompson',
    'UTN1': 'Salehin',
    'MAF6': 'Lionel Triplett',
    'UNY4': 'Weiner',
    'UTX4': 'Hill',
    'MAG5': 'Tracy Gokce',
    'UNV2': 'Linville',
    'UCA5': 'Toscano',
    'UFL5': 'Persaud',
    'UVA4': 'Weiner',
    'MAF5': 'Kevin Johnson',
    'UMD1': 'Weiner',
    'ULO6': 'Alex Gollings',
    'UMC3': 'Dave Barton',
    'UMU1': 'Seti Sadaghiani',
    'MAB4': 'Meyali Staup',
    'MAH2': 'Martha Marinelli',
    'MAQ9': 'Stockton Young',
    'MAF1': 'Tracy Gokce',
    'MAC2': 'Kevin Johnson',
    'UNC3': 'Alzola',
    'MAB7': 'Stockton Young',
    'MAE3': 'Martha Marinelli',
    'MAH5': 'Tracy Gokce',
    'MAO6': 'Kevin Johnson',
    'MAI2': 'Lionel Triplett',
    'UMA4': 'Gogliormella',
    'MAF8': 'Meyali Staup',
    'UWA5': 'Linville',
    'MAF3': 'Meyali Staup',
    'MAK1': 'Martha Marinelli',
    'MBA6': 'Deron Thompson',
    'MAL2': 'Martha Marinelli',
    'UVL1': 'Santiago Ladegui Alfonso',
    'UIT7': "Pietro D'Agostini",
    'MAJ8': 'Kevin Johnson',
    'ULA6': 'Toscano',
    'USF4': 'Coleman',
    'UNY2': 'Denman',
    'MAQ8': 'Stockton Young',
    'MAO4': 'Lionel Triplett',
    'MAE4': 'Martha Marinelli',
    'UOH5': 'Salehin',
    'UNV3': 'Jans',
    'MAE9': 'Lionel Triplett',
    'MAC4': 'Kevin Johnson',
    'MAG3': 'Martha Marinelli',
    'UTX9': 'Salehin',
    'UDE6': 'Lars Borrmann',
    'MAH8': 'Deron Thompson',
    'MAT8': 'Tracy Gokce',
    'MAB8': 'Deron Thompson',
    'UUK2': 'Ben Westhead',
    'MAC1': 'Martha Marinelli',
    'MAG4': 'Martha Marinelli',
    'MAK3': 'Lionel Triplett',
    'MAF9': 'Kevin Johnson',
    'UUK3': 'Sukhi Nagra',
    'UAZ1': 'Jans',
    'MAJ7': 'Carl Andersen',
    'UMN1': 'Hill',
    'UES3': 'David Gomez Fernandez',
    'UHA1': 'Jonas Kahle',
    'UTX8': 'Hill',
    'UIT4': 'Luca Lamberti',
    'UCA4': 'Toscano',
    'UTR1': 'Margherita Basso',
    'UWA2': 'Nielson',
    'MAH0': 'Lionel Triplett',
    'ULO5': 'Megan Bentley',
    'MAO7': 'Lionel Triplett',
    'MAI7': 'Lionel Triplett',
    'MAV2': 'Tracy Gokce',
    'MAG9': 'Lionel Triplett',
    'UIN1': 'Salehin',
    'MAM5': 'Lionel Triplett',
    'UCO1': 'Jans',
    'UCA1': 'Coleman',
    'UJF2': 'Yoshihiro Morimoto',
    'UPA1': 'Weiner',
    'MAE6': 'Kevin Johnson',
    'MAG6': 'Carl Andersen',
    'MAI6': 'Lionel Triplett',
    'UGA2': 'Alzola',
    'UWA1': 'Nielson',
    'UFL4': 'Persaud',
    'UOR2': 'Nielson',
    'UES4': 'David Blanco Real',
    'MAM9': 'Stockton Young',
    'MAG1': 'Meyali Staup',
    'UNC2': 'Alzola',
    'UVA5': 'Weiner',
    'UGA4': 'Alzola',
    'MAK9': 'Meyali Staup',
    'MAF4': 'Meyali Staup',
    'MAC9': 'Kevin Johnson',
    'MAI1': 'Stockton Young',
    'UVA1': 'Weiner',
    'UJF1': 'Yoshihiro Morimoto',
    'MAK7': 'Carl Andersen',
    'MAL0': 'Carl Andersen',
    'UIT1': "Pietro D'Agostini",
    'UTX7': 'Hill',
    'UUK1': 'James Eadon',
    'JFK2': 'Gogliormella',
    'UZR1': 'Rafael Ara caballero',
    'USD1': 'Toscano',
    'MAN0': 'Carl Andersen',
    'MAB3': 'Carl Andersen',
    'MAB5': 'Meyali Staup'
};
